import React, { useState } from "react";
import {
  Card,
  CardBody,
  Table,
  Input,
  Row,
  Col,
  Button,
} from "reactstrap";


const cardShell = {
  background: "var(--vz-secondary-bg, #fff)",
  border: "1px solid var(--vz-border-color)",
  borderRadius: 10,
  boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
  overflow: "hidden",
};


const IncidentQueueTable = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const incidents = [
    {
      name: "Unauthorized Access Attempt on Production Database",
      severity: "Critical",
      source: "Endpoint Security",
      assignedTo: "Alice Johnson",
      playbookUsed: "P-DB-001",
      status: "Open",
    },
    {
      name: "Service Degradation: API Latency Spikes",
      severity: "High",
      source: "Monitoring System",
      assignedTo: "Bob Williams",
      playbookUsed: "P-API-003",
      status: "In Progress",
    },
    {
      name: "Malware Detected on User Workstation",
      severity: "High",
      source: "Antivirus Software",
      assignedTo: "Charlie Davis",
      playbookUsed: "P-EMP-005",
      status: "Open",
    },
    {
      name: "Unexpected System Shutdown in Staging",
      severity: "Medium",
      source: "Server Logs",
      assignedTo: "Dana Miller",
      playbookUsed: "P-INF-002",
      status: "Closed",
    },
    {
      name: "High CPU Usage on Web Server",
      severity: "Medium",
      source: "Cloud Monitoring",
      assignedTo: "Eve Green",
      playbookUsed: "P-WEB-007",
      status: "In Progress",
    },
  ];

  const filteredIncidents = incidents.filter((incident) =>
    incident.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const getSeverityBadge = (severity) => {
    switch (severity) {
      case "Critical": return { color: "#dc2626", border: "1px solid rgba(239, 68, 68, 0.3)" };
      case "High": return { color: "#FF5B00", border: "1px solid rgba(251, 191, 36, 0.3)" };
      case "Medium": return { color: "#dbd95aff", border: "1px solid rgba(132, 167, 38, 0.3)" };
      case "Low": return { color: "#d39043", border: "1px solid rgba(206, 133, 64, 0.3)" };
      default: return { color: "#374151", border: "1px solid #d1d5db" };
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case "Closed": return { color: "#29bd15ff", border: "1px solid rgba(139, 170, 67, 0.3)" };
      case "In Progress": return { color: "#FF5B00", border: "1px solid rgba(251, 191, 36, 0.3)" };
      case "Open": return { color: "#dbd95aff", border: "1px solid rgba(132, 167, 38, 0.3)" };
      default: return { color: "#374151", border: "1px solid #d1d5db" };
    }
  };

  return (
    <div className="p-4">
      <h4 className="fw-bold mb-4">Incident Queue</h4>

      <Card className="shadow-sm border-0" style={cardShell}>
        <CardBody>

          <Row className="align-items-center mb-4">
            <Col className="d-flex flex-wrap align-items-center gap-2">
              <div>
                <label className="form-label small mb-1">Severity</label>
                <Input
                  type="select"
                  style={{ minWidth: "140px", fontSize: "14px" }}
                  bsSize="sm"
                >
                  <option>All Severities</option>
                  <option>Critical</option>
                  <option>High</option>
                  <option>Medium</option>
                  <option>Low</option>
                </Input>
              </div>

              <div>
                <label className="form-label small mb-1">Status</label>
                <Input
                  type="select"
                  style={{ minWidth: "140px", fontSize: "14px" }}
                  bsSize="sm"
                >
                  <option>All Statuses</option>
                  <option>Open</option>
                  <option>In Progress</option>
                  <option>Closed</option>
                </Input>
              </div>

              <div>
                <label className="form-label small mb-1">Assigned To</label>
                <Input
                  type="text"
                  placeholder="Search by name..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{ minWidth: "180px", fontSize: "14px" }}
                  bsSize="sm"
                />
              </div>

              <div className="mt-3">
                <Button
                  color="light"
                  size="sm"
                  className="d-flex align-items-center gap-1"
                  style={{ fontSize: "13px" }}
                >
                  Clear Filters
                </Button>
              </div>
            </Col>
          </Row>


          <Row className="mb-4">
            <Col className="d-flex gap-2">
              <Button
                size="sm"
                className="d-flex align-items-center gap-1"
                style={{
                  backgroundColor: "#EAEAEB",
                  border: "none",
                  color: "#000",
                  fontWeight: "500",
                }}
              >
                Close Selected (0)
              </Button>
              <Button
                color="light"
                size="sm"
                className="d-flex align-items-center gap-1"
              >
                Reassign Selected
              </Button>
              <Button
                color="light"
                size="sm"
                className="d-flex align-items-center gap-1"
              >
                Run Playbook
              </Button>
            </Col>
          </Row>

          {/* Table */}
          <div className="table-responsive">
            <Table bordered hover responsive className="align-middle mb-0">
              <thead className="table-white">
                <tr>
                  <th style={{ width: "30px" }}>
                    <Input type="checkbox" />
                  </th>
                  <th>Incident Name</th>
                  <th>Severity</th>
                  <th>Source</th>
                  <th>Assigned To</th>
                  <th>Playbook Used</th>
                  <th>Status</th>
                  <th style={{ minWidth: "160px" }}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredIncidents.map((incident, index) => (
                  <tr key={index}>
                    <td>
                      <Input type="checkbox" />
                    </td>
                    <td>{incident.name}</td>
                    <td>
                      <span className="badge rounded-pill" style={getSeverityBadge(incident.severity)} >
                        {incident.severity}
                      </span>
                    </td>
                    <td>{incident.source}</td>
                    <td>{incident.assignedTo}</td>
                    <td>{incident.playbookUsed}</td>
                    <td>
                      <span className="badge rounded-pill" style={getStatusBadge(incident.status)} > 
                        {incident.status} </span>
                    </td>
                    <td>
                      <div className="d-flex gap-1">
                        <Button
                          size="sm"
                          style={{
                            backgroundColor: "rgba(7, 82, 57, 0.1)",
                            color: "#9c9999ff",
                            border: "1px solid #FF5B00",
                            padding: "5px 12px",
                            borderRadius: "6px",
                            fontSize: "11px",
                            fontWeight: "500",
                            textDecoration: "none"
                          }}
                        >
                          View Details
                        </Button>
                        <Button
                          color="light"
                          size="sm"
                          style={{ fontSize: "12px", padding: "4px 12px" }}
                        >
                          Assign
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default IncidentQueueTable;